export function createCspDirectives(
	cspConfig: Record<string, string[]>,
): string {
	return Object.entries(cspConfig)
		.map(([key, values]) => `${key} ${values.join(" ")}`)
		.join("; ");
}
